import BackButtonRow from "../../Common/DetailsForm/Fragments/BackButtonRow";
import { httpGet } from "../../Common/Http/httpGet";
import LoadingContentWrapper from "../../Common/Loading/LoadingContentWrapper";
import { useEffect, useState } from "react";
import DetailsPresenter from "./DetailsPresenter";
import type { productReturnRequestDisplayVM } from "./productReturnRequestDisplayVM";

export default function Details(props: {
  id: number;
  navigate: (url: string) => void;
  backUrl?: string;
}) {
  const backUrl = props.backUrl || "./../../index";

  const [dataObject, setDataObject] =
    useState<productReturnRequestDisplayVM | undefined>(undefined);

  useEffect(() => {
    const setData = async () => {
      setDataObject(undefined);
      const a = await httpGet<productReturnRequestDisplayVM>(
        "/api/ProductReturns/ProductReturnRequestDetails",
        props.id
      );
      setDataObject(a);
    };

    setData();
  }, [props.id]);

  return (
    <>
      <h1 className="border-bottom pb-2 mt-4 mb-4">
        Karta wniosku o zwrot <b>{dataObject?.code}</b>
      </h1>
      <LoadingContentWrapper isLoading={!dataObject}>
        {!!dataObject && (
          <>
            <DetailsPresenter
              object={dataObject}
            ></DetailsPresenter>
            <BackButtonRow
              onClick={() => {
                props.navigate(backUrl);
              }}
            />
          </>
        )}
      </LoadingContentWrapper>
    </>
  );
}
